export default __webpack_public_path__ + "static/media/meterreading-2.e4db0e3b.png";